import { Checklist } from '../../types/checklist';

export function downloadChecklist(checklist: Checklist): void {
    const checklistItems = [];

    const sortedCategories = checklist.categories.sort((a, b) => (a.name > b.name ? 1 : -1));
    for (const c of sortedCategories) {
        const categoryItems = checklist.checklistItems
            .filter((p) => p.categoryId === c.id)
            .sort((a, b) => (a.sequence > b.sequence ? 1 : -1));

        for (const i of categoryItems) {
            const checklistItem = [`"${i.name}","${i.description || ''}","${c.name}","${i.reportCodes}"`];
            checklistItems.push(checklistItem);
        }
    }

    const uncategorisedItems = checklist.checklistItems.filter((p) => !p.categoryId).sort((a, b) => (a.sequence > b.sequence ? 1 : -1));
    for (const i of uncategorisedItems) {
        const checklistItem = [`"${i.name}","${i.description || ''}","","${i.reportCodes}"`];
        checklistItems.push(checklistItem);
    }

    const CSV = [['"Name *","Description","Category","Report Code *"'], checklistItems.join('\n')].join('\n');
    const file = new Blob([CSV], { type: 'text/csv' });

    const element = document.createElement('a');
    element.href = URL.createObjectURL(file);
    element.download = `${checklist.name.toLowerCase().replaceAll(' ', '-')}.csv`;
    document.body.appendChild(element);
    element.click();
}
